<!-- ========== Left Sidebar Start ========== -->

<ng-template #contentTemplate>

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
   
      <ng-container *ngFor="let item of menuItems">
        
        <!-- Başlık satırları -->
        <li class="menu-title" *ngIf="item.isTitle">{{ item.label }}</li>

        <!-- Normal menü item -->
        <li *ngIf="!item.isTitle && !item.isLayout">
          
          <!-- ALT ITEM VARSA -->
          <a *ngIf="hasItems(item)" href="javascript:void(0);" class="is-parent"
             [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}">
            <i class="bx {{item.icon}}" *ngIf="item.icon"></i>
            <span>{{ item.label }}</span>
            <span class="badge rounded-pill float-end bg-{{item.badge.variant}}" *ngIf="item.badge">
              {{item.badge.text}}
            </span>
          </a>

          <!-- ALT ITEM YOKSA -->
          <a [routerLink]="item.link"
             *ngIf="!hasItems(item)"
             class="side-nav-link-ref"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{ exact: true }">
            <i class="bx {{ item.icon }}" *ngIf="item.icon"></i>
            <span>{{ item.label }}</span>
            <span class="badge rounded-pill bg-{{item.badge.variant}} float-end" *ngIf="item.badge">
              {{item.badge.text}}
            </span>
          </a>

          <!-- ALT MENÜ -->
          <ul *ngIf="hasItems(item)" class="sub-menu" aria-expanded="false">
            <li *ngFor="let subitem of item.subItems">
              
              <!-- Alt item -->
              <a [routerLink]="subitem.link"
                 *ngIf="!hasItems(subitem)"
                 class="side-nav-link-ref"
                 [attr.data-parent]="subitem.parentId"
                 routerLinkActive="active"
                 [routerLinkActiveOptions]="{ exact: true }">
                {{ subitem.label }}
              </a>

              <!-- Alt item de alt item içeriyorsa -->
              <a *ngIf="hasItems(subitem)"
                 class="side-nav-link-a-ref has-arrow"
                 href="javascript:void(0);"
                 [attr.data-parent]="subitem.parentId">
                {{ subitem.label }}
              </a>

              <!-- Alt alt menü -->
              <ul *ngIf="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                <li *ngFor="let subSubitem of subitem.subItems">
                  <a [routerLink]="subSubitem.link"
                     class="side-nav-link-ref"
                     routerLinkActive="active"
                     [routerLinkActiveOptions]="{ exact: true }"
                     [attr.data-parent]="subSubitem.parentId">
                    {{ subSubitem.label }}
                  </a>
                </li>
              </ul>

            </li>
          </ul>
        </li>
      </ng-container>
    </ul>
  </div>
</ng-template>
<!-- Sidebar -->

<div class="vertical-menu">
  <ngx-simplebar class="h-100" #componentRef>
    <div *ngIf="!isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    <div *ngIf="isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </ngx-simplebar>
</div>
<!-- Left Sidebar End -->
